import { createApp } from 'vue'
import App from './App.vue'
import store from '@/store'
import router from '@/router/helpRouter'
import { Lazyload } from 'vant'
import { fs_main } from '@/utils/app'

window.fs_main = fs_main
import directive from "@/utils/directive"
createApp(App).use(store).use(router).use(Lazyload).use(directive).mount('#app')

import VConsole from 'vconsole'
if (location.host == 'test.foshanplus.com' || location.href.includes('vconsole=1')) {
  new VConsole()
}